import { Theme } from '@mui/material'

const useStyles = {
  modalPaper: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.lightSurface,
  }),
  folderContainer: (theme: Theme) => ({
    padding: theme.spacing(2),
    alignItems: 'center',
  }),
  folderContent: {
    alignItems: 'flex-start',
    columnGap: 1,
  },
  spinner: {
    margin: '0 auto',
  },
  locationIcon: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: '2px',
  }),
  currentFolder: {
    backgroundColor: '#1976D20A',
  },
  currentlyViewingText: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    fontWeight: 600,
  }),
  locationWrapper: (theme: Theme) => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    borderRadius: '16px',
    textAlign: 'left',
    display: 'block',
  }),
  locationAddress: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.25px',
  },
  logo: {
    height: '50px',
    marginLeft: '12px',
  },
}

export default useStyles
